import {NgModule} from '@angular/core';

import {MzBadgeComponent} from './badge.component';

@NgModule({
  declarations: [MzBadgeComponent],
  exports: [MzBadgeComponent],
})
export class MzBadgeModule {
}
